import { createStore, createEvent } from 'effector';
import { isEqual } from 'lodash';
import { COLUMN_WIDTH_CONFIG } from '../consts';
import { IDataTableColumn, TDataTableView, TWidthData } from '../models';

type TColWidth = number | string;
type TPayload = {
  data: IDataTableColumn[];
  view: TDataTableView;
  isHasActions?: boolean;
};
type TColumnWidthsStore = Map<string, TWidthData>;
export const ACTIONS_COL = 'actions';
export const $columnsStore = createStore<IDataTableColumn[]>([]);
export const $columnWidthsStore = createStore<TColumnWidthsStore>(new Map());

export const changeColumnWidthEvent = createEvent<{ col: string; width: TColWidth }>();
export const initColumnsEvent = createEvent<TPayload>();

const formatWidth = (width: number | string | undefined) => {
  if (!width) return undefined;
  return typeof width == 'number' ? width + 'px' : width;
};

$columnsStore.on(initColumnsEvent, (state, { data }) => {
  if (isEqual(data, state)) {
    return state;
  }

  return data;
});

$columnWidthsStore.on(initColumnsEvent, (_, { data, view, isHasActions }) => {
  const map: TColumnWidthsStore = new Map(
    data.map((c) => [
      c.id,
      {
        ...COLUMN_WIDTH_CONFIG[c.semanticType],
        width: c.width,
        minWidth: formatWidth(c.minWidth),
        maxWidth: formatWidth(c.maxWidth),
      },
    ]),
  );

  if (isHasActions) {
    map.set(ACTIONS_COL, {
      min: `${view === 'fancy' ? 60 : 48}px`,
      max: 'auto',
    });
  }

  return map;
});
